<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80" style="width: 300px" @mousedown.stop="">
          <div class="modal-body m-0" style="margin: auto;">
            <div v-if="qrCodeIsGenerating" class="center text-center scan-pending">
              <b-spinner></b-spinner>
            </div>
            <qr-code-vue v-else-if="showQRCode" style="text-align: center" :value="accountData.token" size="260" level="M"></qr-code-vue>
            <div class="form" v-else-if="!demoMode">
              <b-row>
              {{$t("bank_accounts.slct_qr_code_content")}}
              </b-row>
              <b-row >
                <b-form-group>
                  <b-form-radio v-model="qrCodeType" name="type-radio" value='1'>
                    IBAN
                  </b-form-radio>
                  <b-form-radio v-model="qrCodeType" name="type-radio" value='2'>
                    QXBAN
                  </b-form-radio>
                  <b-form-radio v-model="qrCodeType" name="type-radio" value='3'>
                    QXBAN Temporaire / One time use
                  </b-form-radio>
                </b-form-group>
              </b-row>
              <b-row v-if="qrCodeType === '3'">
                <label>Durée de validité du QRCode</label>
                <b-input-group>
                  <b-form-input v-model="validityDuration" placeholder="Enter a duration"></b-form-input>
                  <template #append>
                    <b-form-select v-model="durationUnit" :options="listDuration" style="font-size:small;"></b-form-select>
                  </template>
                </b-input-group>
              </b-row>
            </div>
            <b-row>
              <b-col v-if="!demoMode">
                <button v-if="showQRCode" round class="button-action firstButtonMarginTop" @click="newQRCode()">Nouveau QRCode</button>
                <button v-else round class="button-action firstButtonMarginTop" @click="generateQRCode()">{{ $t('common.generate') }}</button>
              </b-col>
              <b-col>
                <button round class="button-action" @click="$emit('close')">{{ $t('common.bck') }}</button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import QrcodeVue from 'qrcode'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'PopupBankAccountQRCode',
  components: {
    'qr-code-vue': QrcodeVue,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    accountId: {
      type: String
    }
  },
  data: () => {
    return {
      accountData: '',
      archiveLabel: '',
      demoMode: true,
      durationUnit: 'm',
      listDuration: [
        { value: 'm', text: 'minutes' },
        { value: 'h', text: 'hours' },
        { value: 'd', text: 'days' }
      ],
      qrCodeType: 3,
      qrCodeIsGenerating: false,
      showQRCode: false,
      validityDuration: '10'
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  mounted () {
    this.generateQRCode()
  },
  methods: {
    generateQRCode () {
      this.qrCodeIsGenerating = true
      console.log(this.accountId)
      var validityDuration = this.validityDurationSend()
      var validityDurationUnit = this.validityDurationUnitSend()
      if (this.demoMode) {
        validityDuration = '10'
        validityDurationUnit = 'm'
      }
      this.$engine.bankAccounts.getBankAccountToken(this.accountId, validityDuration, validityDurationUnit, this.qrCodeType)
        .then(response => {
          this.qrCodeIsGenerating = false
          this.accountData = response.data
          this.showQRCode = true
        })
    },
    newQRCode () {
      this.showQRCode = false
    },
    validityDurationSend () {
      return ((this.qrCodeType === '3') ? this.validityDuration : '')
    },
    validityDurationUnitSend () {
      return ((this.qrCodeType === '3') ? this.durationUnit : '')
    }
  }
}
</script>
<style scoped>
.form {
  margin-left: 20px;
  margin-right: 20px;
}
</style>
